import request from '@/utils/request'

// 查询学习力测评报告详情
export function getHabitReportDetail(assessmentResultId) {
    return request({
        url: '/habit/assessmentResult/getInfoForH5/' + assessmentResultId,
        method: 'get'
    });
}

// 提交志愿模拟
export function submitVolunteerSimulation(params) {
    return request({
        url: '/applet/volunteerSimulation',
        method: 'post',
        data: params
    });
}

// 查询学习力测评报告详情
export function getVolunteerSimulationDetail(reportId) {
    return request({
        url: '/applet/volunteerSimulation/' + reportId,
        method: 'get'
    });
}

// 查询学校详情
export function getSchoolCompleteInfo(schoolId) {
    return request({
        url: '/applet/completeInfo/' + schoolId,
        method: 'get'
    });
}